<template>
  <div class="sales-summary">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4"></div>

          <div class="col-md-4">
            <div class="top-navbar-center">
              Trial

              <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-right">
              <button
                class="btn btn-ecdc"
                @click="$router.push({ name: 'trialsDetails' })"
              >
                Cdc Details
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="summary-list row row-cols-7">
        <div
          :key="`summary-key-${key}`"
          v-for="(dailyRecord, key) in dailyTrail"
          class="col"
        >
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                {{ `DAY ${dailyRecord.day}/${dailyRecord.month}` }}
                <small>
                  {{ `Week ${dailyRecord.week_num}` }}
                </small>
              </h3>

              <div class="figure">
                {{ dailyRecord.number }}
                <small>Trials</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="data-card-list row row-cols-xl-3 row-cols-md-2 row-cols-1 mt-4">
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  TOTAL TRIAL RATE %
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getTotalTrialRate"
                  v-model="totalRateDate"
                >
                  <option value="year">YEAR</option>
                  <option value="month">MONTH</option>
                  <option value="week">WEEK</option>
                </select>
              </div>
            </div>
            <app-line-chart
              :chart-data="totalRateData"
              :options="chartOption"
              :height="250"
            ></app-line-chart>
          </div>
        </div>

        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Area
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getTrialSummaryByAreaData"
                  v-model="trialAreaDate"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <h4 class="section-title">Top Trial</h4>

                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in topTrialArea"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}
                  </dt>
                  <dt class="col-7">
                    {{ data.name }}
                  </dt>
                  <dd class="col-4">{{ data.number }}</dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6 mt-4 mt-sm-0 mt-lg-4 mt-xl-0">
                <h4 class="section-title">Top Non Trial</h4>

                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in topNonTrialArea"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}
                  </dt>
                  <dt class="col-7">
                    {{ data.name }}
                  </dt>
                  <dd class="col-4">{{ data.non_trial_number }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  SOB
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getSobSummaryData"
                  v-model="sobSummaryDate"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in sobSummaryData"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}
                  </dt>
                  <dt class="col-7">
                    {{ data.range.name }}
                  </dt>
                  <dd class="col-4">{{ data.number }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Age Group
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getAgeSummaryData"
                  v-model="ageSummaryDate"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in monthlyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in ageSummaryData"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}
                  </dt>
                  <dt class="col-7">
                    {{ data.age_range }}
                  </dt>
                  <dd class="col-4">{{ data.number }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  TRIAL % WITH PROMOTION
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getTrialWithPromotionRate"
                  v-model="totalRateWithPromotionDate"
                >
                  <option value="year">YEAR</option>
                  <option value="month">MONTH</option>
                  <option value="week">WEEK</option>
                </select>
              </div>
            </div>
            <app-line-chart
              :chart-data="totalRateWithPromotionData"
              :options="chartOption"
              :height="250"
            ></app-line-chart>
          </div>
        </div>

        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  TRIAL % WITHOUT PROMOTION
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getTrialWithNonPromotionRate"
                  v-model="totalRateWithNonPromotionDate"
                >
                  <option value="year">YEAR</option>
                  <option value="month">MONTH</option>
                  <option value="week">WEEK</option>
                </select>
              </div>
            </div>
            <app-line-chart
              :chart-data="totalRateWithNonPromotionData"
              :options="chartOption"
              :height="250"
            ></app-line-chart>
          </div>
        </div>
      </div>
    </div>
    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<script>
import {
  getDashboardDate,
  getTrialSummary,
  getTrialSummaryByCategory,
  getSalesSummaryByCategory
} from "../api";
import { getProj } from "../helpers";
import LineChart from "./chart/LineChart.vue";

import Loader from "./Loader";

export default {
  components: {
    appLineChart: LineChart,
    appLoader: Loader
  },
  data() {
    const moment = require("moment");
    const thisMonday = moment()
      .day("Monday")
      .format("YYYY-MM-DD");
    const startOfMonth = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    return {
      latestUpdateTime: new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear(),
      isLoading: true,
      projectId: getProj()["projId"],
      monthlyDateFilter: [],
      weeklyDateFilter: [],
      dailyTrail: [],
      trialAreaDate: thisMonday,
      topTrialArea: [],
      topNonTrialArea: [],
      sobSummaryDate: thisMonday,
      sobSummaryData: [],
      ageSummaryDate: startOfMonth,
      ageSummaryData: [],
      chartOption: {},
      totalRateDate: "month",
      totalRateData: {},
      totalRateWithPromotionDate: "month",
      totalRateWithPromotionData: {},
      totalRateWithNonPromotionDate: "month",
      totalRateWithNonPromotionData: {}
    };
  },
  async mounted() {
    await this.getDate();
    await this.getTrialDailySummaryData();
    await this.getTrialSummaryByAreaData();
    await this.getSobSummaryData();
    await this.getAgeSummaryData();
    await this.getTotalTrialRate();
    await this.getTrialWithPromotionRate();
    await this.getTrialWithNonPromotionRate();
    this.isLoading = false;
  },
  methods: {
    async getDate() {
      try {
        const monthlyParams = { dateType: "month" };
        const weeklyParams = { dateType: "week" };
        const result = await Promise.all([
          getDashboardDate(monthlyParams),
          getDashboardDate(weeklyParams)
        ]);
        this.monthlyDateFilter = result[0].data.data.dates;
        this.weeklyDateFilter = result[1].data.data.dates;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getTrialDailySummaryData() {
      try {
        const params = {
          projectId: this.projectId,
          dateType: "day",
          type: "normal"
        };
        const result = await getTrialSummary(params);
        this.dailyTrail = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getTrialSummaryByAreaData() {
      try {
        const params = {
          projectId: this.projectId,
          category: "area",
          date: this.trialAreaDate
        };
        const result = await getTrialSummaryByCategory(params);
        this.topTrialArea = result.data.data.statistics.topTrial;
        this.topNonTrialArea = result.data.data.statistics.topNonTrial;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getSobSummaryData() {
      try {
        const params = {
          projectId: this.projectId,
          category: "range",
          date: this.sobSummaryDate
        };
        const result = await getSalesSummaryByCategory(params);
        this.sobSummaryData = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getAgeSummaryData() {
      try {
        const params = {
          projectId: this.projectId,
          category: "age",
          date: this.ageSummaryDate
        };
        const result = await getTrialSummaryByCategory(params);
        this.ageSummaryData = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getTotalTrialRate() {
      try {
        let result = await this.getTrialRateSummary(this.totalRateDate);
        this.totalRateData = this.filterChart(
          result.data.data.statistics,
          "totalRateDate",
          "percentage_trial_over_engagement"
        );
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getTrialWithPromotionRate() {
      try {
        let result = await this.getTrialRateSummary(this.totalRateDate);
        this.totalRateWithPromotionData = this.filterChart(
          result.data.data.statistics,
          "totalRateWithPromotionDate",
          "percentage_trial_over_total_trial"
        );
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getTrialWithNonPromotionRate() {
      try {
        let result = await this.getTrialRateSummary(this.totalRateDate);
        this.totalRateWithNonPromotionData = this.filterChart(
          result.data.data.statistics,
          "totalRateWithNonPromotionDate",
          "percentage_non_trial_over_total_trial"
        );
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getTrialRateSummary(dateType) {
      const params = {
        projectId: this.projectId,
        dateType,
        type: "promotion"
      };
      return await getTrialSummary(params);
    },
    filterChart(chartData, dateColumn, column) {
      let labels = [];
      let data = [];

      chartData.forEach(item => {
        if (this[dateColumn] == "week") labels.push(`WEEK ${item.week_num}`);
        if (this[dateColumn] == "month")
          labels.push(`${item.year}-${item.month}`);
        if (this[dateColumn] == "year") labels.push(item.year);
        data.push(item[column]);
      });

      return {
        labels: labels,
        datasets: [
          {
            label: "percetage",
            backgroundColor: "rgba(0, 0, 0, 0)",
            borderColor: "#FDCD08",
            borderWidth: 2,
            lineTension: 0,
            data: data
          }
        ]
      };
    }
  }
};
</script>
